<template>
    <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'childrenAccount',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: '',
      wxaPageParam: '',
      shareHaderName: '子账号开户',
      pageConfig: {
        sections: [
          {
            head: {
              title: '子账号开户',
            },
            steps: [
              {
                description: [
                  '店铺管理员账号支持创建多个子账号，登录后点击店铺名称进入个人中心；',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '11_01',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
              {
                description: ['选择「成员管理」，点击「新增」按钮；'],
                sub: [
                  {
                    images: [
                      {
                        name: '11_02',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
              {
                description: [
                  '填写成员基本信息，点击保存即账号创建成功！成员可通过此处填写的账号和密码登录。',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '11_03',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '子账号开户',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/childrenAccount.vue